import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { VOUCHER_TYPE_PATH } from '../../../../config/paths';
import { clearVoucherType, getVoucherType } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import VoucherTypeToolbar from './VoucherTypeToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import VoucherTypeBasicInformationResource from './resource/VoucherTypeBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const VoucherType = ({
  breadcrumbs,
  match: {
    params: { id: voucherTypeId },
  },
  voucherType,
  loading,
  dispatchGetVoucherType,
  dispatchClearVoucherType,
}) => {
  useLayoutEffect(() => {
    dispatchGetVoucherType({ voucherTypeId });

    return () => dispatchClearVoucherType();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (voucherType.isEmpty()) {
    content = <NoDataResource returnPage={VOUCHER_TYPE_PATH} />;
  } else {
    const voucherTypeJSON = voucherType.toJS();
    content = (
      <>
        <h3>Información Básica</h3>
        <VoucherTypeBasicInformationResource {...voucherTypeJSON} />
        <InternalResource id={voucherTypeJSON.id}
                  createDate={voucherTypeJSON.createDate}
                  lastUpdate={voucherTypeJSON.lastUpdate}/>
      </>
    );
    toolbar = <VoucherTypeToolbar voucherTypeId={voucherTypeJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Tipo de Comprobante"
      toolbar={toolbar}
      content={content}
    />
  );
};

VoucherType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  voucherType: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetVoucherType: PropTypes.func.isRequired,
  dispatchClearVoucherType: PropTypes.func.isRequired,
};

VoucherType.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Comprobantes',
      href: VOUCHER_TYPE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  voucherType: AccountingUnit.VoucherType.getIn(['current', 'content']),
  loading: !AccountingUnit.VoucherType.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetVoucherType: getVoucherType,
  dispatchClearVoucherType: clearVoucherType,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherType);
